<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">平台赋能面馆活动引爆营销</div>
        <div class="text text3">
          当今时代挣钱不易，打工对于大多数人来说可能一辈子挣不了多少钱，只能解决基本问题。相信很多朋友有创业的想法，餐饮业是一个很好的选择，而开一个面馆，成本较低，盈利也不错，是很多创业者的选择。
          <br />

          今天米创科技跟大家介绍一家面馆的案例。这个面馆开在一个写字楼的旁边，离写字楼近，升级装修后，装的很用心，总共设有70多个座位，算是比较大的面馆了，当然不仅仅是做面，还有很多配菜、酒水之类的。
           厨房做面的师傅跟他好多年了，做面手艺好，回头客多。
          <br />

          通过查看周边的环境，调查写字楼的人员情况，以及老板拥有的资源，我们决定玩一个不一样的模式——底价吃面。

          <br />
          第一，老板推出了一个让人无法拒绝的超级主张，店里的面食全部底价销售，列了一个店里所有面食的价格清单，只需要办理一张店里的会员卡，加入面馆的会员群即可；

          <br />

          第二，会员卡不需要花钱，不需要充值，不限消费金额，仅需缴纳99元的押金，随时可退，退还100元；
          <br />

          第三，凭会员卡和会员群可以提前预约定位，订满为止；
          <br />

          第四，会员群内不定时送出超级福利，每天享受1元秒杀，团购优惠；
          <br />

          第五，会员邀请朋友办卡，免费吃面1次，送特色饮料1瓶。
          <br />

          活动一推出，直接引爆，第一天办理会员卡300多张，第二天更火爆，总共办理了500多张，后面连续火爆了好几天，持续一周下来总共办理了2682张会员卡。
          老板有很多朋友做什么的都有，捋了一遍，找出来20多家，做西餐的、健身房的、KTV的、火锅店、养生馆、美容会所、家具、服装、汽车美容等等，然后针对他们推出了一个超级服务，把我们面馆的会员和客户倒给他们。
          具体怎么操作呢？
          <br />

          第一，找到其中任何一家，让他们设计超级优惠和福利，作为赠品送给我们的会员和顾客；
          <br />

          第二，给一个联系微信，帮他们引导会员和顾客添加；
          <br />

          第三，每增加一个会员添加这个微信，收取5元钱；
          <br />

          第四，保证每一个微信都是真实的店里的顾客和会员。
          <br />

          就这样，每一个老板但凡来店看一看，到周边稍微做个调查就会发现这是一个值得干的好买卖，基本上都选择了合作。
           
          <br />

          就这样，这家面馆没有靠卖面一个月多收13万多。
          <br />

          这个操作值得你借鉴，只要顾客资源优质，很多时候老板们都非常愿意合作。
        </div>
        
        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div @click="shareToQQ()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"></div>
            <div @click="WeixinJSBridge()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"></div>
            <div  @click="shareToMicroblog()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">用2个步骤，一周新增628客户，营收91万！</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1"

      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq = "https://api.pwmqr.com/qrcode/create/?url=" +

          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(qqqq, 'newwindow', 'height=400,width=400,top=200,left=600');

    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1"
      };
      var wwww = "https://api.pwmqr.com/qrcode/create/?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(wwww, 'newwindow', 'height=400,width=400,top=200,left=600');
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/"
      };
      //跳转地址
      var bbbb =  "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"

        window.open(bbbb, 'newwindow', 'height=1000,width=1000,top=200,left=100');
    },
     tiaozhuan(e){
      if( e == 3){
        this.$router.push({
        path: "/alxq5",
      });
      }else if( e == 2){
      this.$router.push({
        path: "/alxq4",
      });
      }else if( e == 1){
        this.$router.push({
        path: "/alxq2",
      });
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url('../../assets/images/1625137306(1).jpg') no-repeat center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq1/index.vue